module.exports = __webpack_public_path__ + "static/img/p1.90a907e7.png";